@charset "UTF-8";
:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._recommendedMobileHeaderHeight_vvfu4_8 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; }
  ._recommendedMobileHeaderHeight_vvfu4_8 > ._headerFooterInfoTooltip_vvfu4_15 {
    position: absolute;
    background: #f7f8f8;
    padding-right: 25px;
    max-width: 200px;
    height: 28px;
    pointer-events: auto; }
    ._recommendedMobileHeaderHeight_vvfu4_8 > ._headerFooterInfoTooltip_vvfu4_15 ._headerTooltipContent_vvfu4_22 {
      display: flex;
      align-items: center; }
      ._recommendedMobileHeaderHeight_vvfu4_8 > ._headerFooterInfoTooltip_vvfu4_15 ._headerTooltipContent_vvfu4_22 > ._recommendedMobileHeaderHeightTitle_vvfu4_25 {
        font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
        font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
        font-weight: var(--wbu-font-weight-regular);
        font-size: 12px;
        -webkit-font-smoothing: antialiased;
        display: inline-block;
        line-height: 14px;
        margin-left: 10px;
        text-align: start;
        color: #868aa5; }
      ._recommendedMobileHeaderHeight_vvfu4_8 > ._headerFooterInfoTooltip_vvfu4_15 ._headerTooltipContent_vvfu4_22 > ._styles_vvfu4_36._recommendedMobileHeaderInfoIcon_vvfu4_36 {
        fill: #868aa5; }
        ._recommendedMobileHeaderHeight_vvfu4_8 > ._headerFooterInfoTooltip_vvfu4_15 ._headerTooltipContent_vvfu4_22 > ._styles_vvfu4_36._recommendedMobileHeaderInfoIcon_vvfu4_36 circle {
          fill: transparent; }
  ._recommendedMobileHeaderHeight_vvfu4_8 > svg._headerRecommendedHeightSeparator_vvfu4_40 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    shape-rendering: crispEdges; }
    ._recommendedMobileHeaderHeight_vvfu4_8 > svg._headerRecommendedHeightSeparator_vvfu4_40 > line._headerRecommendedHeightSeparator_vvfu4_40 {
      stroke-width: 0.5px;
      stroke: #bcbcbc;
      stroke-dasharray: 0; }
